/* SparkleCraft advertorial/product interactions for Shopify-hosted pages. */
(function () {
  'use strict';

  var config = window.SPARKLECRAFT_CONFIG || {};
  var isProduct = config.pageType === 'product';
  var variants = window.SPARKLECRAFT_VARIANTS || {};
  var cartSettings = window.SPARKLECRAFT_CART_SETTINGS || {};
  var googleAds = config.googleAds || {};
  var navigationPending = false;

  function googleSendTo(label) {
    var conversionId = String(googleAds.conversionId || '').trim();
    label = String(label || '').trim();
    if (!/^AW-\d+$/.test(conversionId) || !label) return '';
    return conversionId + '/' + label;
  }

  function navigateWithConversion(label, url) {
    if (!url || navigationPending) return;
    navigationPending = true;
    var completed = false;
    var navigate = function () {
      if (completed) return;
      completed = true;
      window.location.assign(url);
    };
    var sendTo = googleSendTo(label);
    if (!sendTo || typeof window.gtag !== 'function') {
      navigate();
      return;
    }
    window.setTimeout(navigate, 1200);
    try {
      window.gtag('event', 'conversion', { send_to: sendTo, event_callback: navigate });
    } catch (error) {
      navigate();
    }
  }

  function withCurrentQuery(base) {
    if (!base) return '';
    try {
      var target = new URL(base, window.location.origin);
      var current = new URLSearchParams(window.location.search);
      var targetOwnedParams = {};
      var shopifyOnlyParams = {
        view: true,
        preview_theme_id: true,
        preview_script_debug: true,
        _fd: true,
        pb: true,
        section_id: true
      };
      target.searchParams.forEach(function (value, key) {
        targetOwnedParams[key] = true;
      });
      current.forEach(function (value, key) {
        if (!shopifyOnlyParams[key] && !targetOwnedParams[key]) {
          target.searchParams.append(key, value);
        }
      });
      var query = target.searchParams.toString();
      if (target.searchParams.has('checkout') && target.searchParams.get('checkout') === '') {
        query = query.replace(/(^|&)checkout=(?=&|$)/, '$1checkout');
      }
      return target.pathname + (query ? '?' + query : '') + target.hash;
    } catch (error) {
      return base;
    }
  }

  function productRows() {
    return document.querySelectorAll('.product-item-v8[data-spc-option]');
  }

  function variantIdFor(row) {
    if (!row) return '';
    var configured = variants[row.dataset.spcOption];
    var value = configured && typeof configured === 'object' ? configured.variantId : configured;
    value = value == null ? '' : String(value).trim();
    return /^\d+$/.test(value) ? value : '';
  }

  function quantityFor(row) {
    var input = row && row.querySelector('.product-row-quantity-input-v8');
    var value = input ? parseInt(input.value, 10) : 0;
    if (!Number.isFinite(value)) value = 0;
    value = Math.max(0, Math.min(99, value));
    if (input) input.value = String(value);
    return value;
  }

  function activeRows() {
    return Array.from(productRows()).filter(function (row) {
      return quantityFor(row) > 0;
    });
  }

  function rowSummary(row) {
    var name = row && row.querySelector('.product-row-variant-v8');
    var price = row && row.querySelector('.product-row-sales-price-v8');
    var rawPrice = price ? price.textContent.replace(/[^0-9.,-]/g, '').replace(/,/g, '') : '';
    var numericPrice = parseFloat(rawPrice);
    return {
      name: name ? name.textContent.replace(/\s+/g, ' ').trim() : '',
      priceText: price ? price.textContent.trim() : '',
      numericPrice: Number.isFinite(numericPrice) ? numericPrice : 0
    };
  }

  function formatUsd(value) {
    return '$' + value.toFixed(2);
  }

  function updateOrderSummary() {
    if (!isProduct) return;
    var items = document.querySelector('.spc-order-summary-items');
    var subtotalText = document.querySelector('.spc-order-summary-subtotal');
    var headerTotal = document.querySelector('.spc-order-summary-header-total');
    var subtotal = 0;
    if (items) items.replaceChildren();

    activeRows().forEach(function (row) {
      var details = rowSummary(row);
      var quantity = quantityFor(row);
      var lineTotal = details.numericPrice * quantity;
      subtotal += lineTotal;
      if (!items) return;

      var line = document.createElement('div');
      line.className = 'spc-order-summary-line spc-order-summary-product-line';
      var name = document.createElement('span');
      name.className = 'spc-order-summary-name';
      name.textContent = details.name;
      var priceGroup = document.createElement('span');
      priceGroup.className = 'spc-order-summary-price-group';
      var quantityText = document.createElement('span');
      quantityText.className = 'spc-order-summary-quantity';
      quantityText.textContent = '×' + quantity;
      var linePrice = document.createElement('strong');
      linePrice.className = 'spc-order-summary-unit-price';
      linePrice.textContent = formatUsd(lineTotal);
      priceGroup.append(quantityText, linePrice);
      line.append(name, priceGroup);
      items.append(line);
    });

    if (items && !items.children.length) {
      var empty = document.createElement('p');
      empty.className = 'spc-order-summary-empty';
      empty.textContent = 'Your cart is empty. Use the + buttons above to add a design.';
      items.append(empty);
    }

    var formattedSubtotal = formatUsd(subtotal);
    if (subtotalText) subtotalText.textContent = formattedSubtotal;
    if (headerTotal) headerTotal.textContent = formattedSubtotal;
  }

  function updateRowStates() {
    productRows().forEach(function (row) {
      var active = quantityFor(row) > 0;
      row.classList.toggle('spc-selected', active);
      row.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }

  function refreshProduct() {
    updateRowStates();
    updateAddToCart();
    updateOrderSummary();
  }

  function updateAddToCart() {
    if (!isProduct) return;
    var rows = activeRows();
    var hasItems = rows.length > 0;
    var ready = hasItems && rows.every(function (row) { return Boolean(variantIdFor(row)); });
    document.querySelectorAll('.spc-add-to-cart').forEach(function (button) {
      button.disabled = !ready;
      button.classList.toggle('spc-checkout-pending', !ready);
      button.setAttribute('aria-disabled', ready ? 'false' : 'true');
      button.setAttribute('title', ready ? 'Continue with selected items' : (hasItems ? 'Configure the selected variants in theme settings' : 'Choose at least one item'));
    });
  }

  function bindQuantity(row) {
    var input = row.querySelector('.product-row-quantity-input-v8');
    var minus = row.querySelector('.spc-qty-minus');
    var plus = row.querySelector('.spc-qty-plus');
    if (!input) return;

    function change(delta) {
      input.value = String(quantityFor(row) + delta);
      quantityFor(row);
      refreshProduct();
    }
    if (minus) {
      minus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        change(-1);
      });
      minus.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          change(-1);
        }
      });
    }
    if (plus) {
      plus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        change(1);
      });
      plus.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          change(1);
        }
      });
    }
    input.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    input.addEventListener('change', function () {
      quantityFor(row);
      refreshProduct();
    });
  }

  function initializeProduct() {
    var rows = productRows();
    if (!rows.length) return;

    document.querySelectorAll('.spc-order-summary-note').forEach(function (note) {
      note.remove();
    });

    function toggleRow(row) {
      var input = row.querySelector('.product-row-quantity-input-v8');
      if (!input) return;
      var quantity = quantityFor(row);
      if (quantity === 0) input.value = '1';
      else if (quantity === 1) input.value = '0';
      refreshProduct();
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function (event) {
        if (event.target.closest('.spc-quantity')) return;
        toggleRow(row);
      });
      row.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleRow(row);
        }
      });
      bindQuantity(row);
      quantityFor(row);
    });
    refreshProduct();
  }

  function initializeAdvertorial() {
    var target = withCurrentQuery(config.productUrl);
    document.querySelectorAll('a[href="/pages/sparklecraft-product"]').forEach(function (anchor) {
      anchor.setAttribute('href', target);
      anchor.removeAttribute('target');
    });
  }

  document.addEventListener('click', function (event) {
    var productButton = event.target.closest && event.target.closest('.spc-add-to-cart');
    if (productButton) {
      event.preventDefault();
      var rows = activeRows();
      if (!rows.length || rows.some(function (row) { return !variantIdFor(row); })) return;
      var cartLines = rows.map(function (row) {
        return encodeURIComponent(variantIdFor(row)) + ':' + quantityFor(row);
      });
      var cartUrl = '/cart/' + cartLines.join(',');
      if (cartSettings.redirectToCheckout !== false) cartUrl += '?checkout';
      cartUrl = withCurrentQuery(cartUrl);
      navigateWithConversion(googleAds.beginCheckoutLabel, cartUrl);
      return;
    }

    var advertorialLink = event.target.closest && event.target.closest('a[href^="/pages/sparklecraft-product"]');
    if (!isProduct && advertorialLink) {
      event.preventDefault();
      navigateWithConversion(googleAds.addToCartLabel, withCurrentQuery(config.productUrl));
    }
  }, true);

  function initialize() {
    if (isProduct) initializeProduct();
    else initializeAdvertorial();
    updateAddToCart();
    updateOrderSummary();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
